/**
 * Appends UTM parameters to a given link if they exist in the current window's URL.
 *
 * @param link The link to which UTM parameters are to be appended.
 * @returns The link with appended UTM parameters, if they exist;
 *          otherwise, returns the original link.
 */

const appendUTMParams = link => {
  // FIXME - Add back in when SEO issue is resolved.
  // try {
  //   const queryString =
  //     typeof window === 'undefined' ? '' : window?.location?.search || '';
  //   const urlSearchParams = new URLSearchParams(queryString);

  //   const utmParams = Array.from(urlSearchParams.entries())
  //     .filter(([key]) => key.startsWith('utm_'))
  //     .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
  //     .join('&');

  //   if (utmParams) {
  //     return link.includes('?')
  //       ? `${link}&${utmParams}`
  //       : `${link}?${utmParams}`;
  //   }

  //   return link;
  // } catch (error) {
  //   return link;
  // }
  return link;
};

export default appendUTMParams;
